// home.js
import React from 'react';

import General from './General';
import PhisicFinance from './PhisicFinance';
import Balance from './Balance';
import Report from './Report';

import { TabContent, TabPane, Nav, NavItem, NavLink, Col } from 'reactstrap';
import classnames from 'classnames';

import '../home/Home.css';

const Organization = ({ showNav, activeTab, setActiveTab }) => {
    return (
        <div
            className="mt-3 mr-3"
            style={{
                marginLeft: '30px'
            }}
        >
            {showNav && (
                <Nav tabs>
                    <NavItem>
                        <NavLink
                            style={{ cursor: 'pointer' }}
                            className={classnames({
                                active: activeTab === 'general'
                            })}
                            onClick={() => {
                                setActiveTab('general');
                            }}
                        >
                            Relatórios
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            style={{ cursor: 'pointer' }}
                            className={classnames({
                                active: activeTab === 'phisic_finance'
                            })}
                            onClick={() => {
                                setActiveTab('phisic_finance');
                            }}
                        >
                            Físico-Financeiro
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            style={{ cursor: 'pointer' }}
                            className={classnames({
                                active: activeTab === 'balance'
                            })}
                            onClick={() => {
                                setActiveTab('balance');
                            }}
                        >
                            Balanço
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            style={{ cursor: 'pointer' }}
                            className={classnames({
                                active: activeTab === 'report'
                            })}
                            onClick={() => {
                                setActiveTab('report');
                            }}
                        >
                            Parecer
                        </NavLink>
                    </NavItem>
                </Nav>
            )}
            <TabContent activeTab={activeTab} className="bg-white">
                <TabPane tabId="general">
                    <Col sm="12">
                        <General />
                    </Col>
                </TabPane>
                <TabPane tabId="phisic_finance">
                    <Col sm="12">
                        <PhisicFinance />
                    </Col>
                </TabPane>
                <TabPane tabId="balance">
                    <Col sm="12">
                        <Balance />
                    </Col>
                </TabPane>
                <TabPane tabId="report">
                    <Col sm="12">
                        <Report />
                    </Col>
                </TabPane>
            </TabContent>
        </div>
    );
};

export default Organization;
